module.exports = __webpack_public_path__ + "9608cca09221340e00603d6108777081.png";